import * as React from "react";
import { forwardRef } from "react";
const SvgMic = (props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    ref={ref}
    {...props}
  >
    <path d="M50 0c-8.97 0-16.242 7.272-16.242 16.242v36.546c0 8.97 7.272 16.242 16.242 16.242s16.242-7.272 16.242-16.242V16.242C66.242 7.272 58.97 0 50 0" />
    <path d="M23.615 51.848a4.51 4.51 0 0 0-4.445 4.576c0 15.441 11.468 28.3 26.318 30.496v8.504a4.512 4.512 0 1 0 9.024 0V86.92c14.85-2.196 26.319-15.055 26.318-30.496a4.512 4.512 0 1 0-9.024 0A21.74 21.74 0 0 1 50 78.232a21.74 21.74 0 0 1-21.806-21.808 4.51 4.51 0 0 0-4.58-4.576" />
  </svg>
);
const ForwardRef = forwardRef(SvgMic);
export default ForwardRef;
